import React from "react";
import { fuzzyMatchText, mergeHighlightRanges } from "../fuzzySearch";

const DEFAULT_MARK_CLASS_NAME =
	"rounded-sm bg-[var(--color-accent-muted)] px-0.5 text-[var(--color-text-primary)]";

export const HighlightedText = ({
	children,
	query,
	className = "",
	markClassName = "",
}) => {
	const text = String(children ?? "");
	const { ranges } = fuzzyMatchText(text, query);
	const highlightRanges = mergeHighlightRanges(ranges);
	const markerClassName = markClassName
		? `${DEFAULT_MARK_CLASS_NAME} ${markClassName}`
		: DEFAULT_MARK_CLASS_NAME;

	if (highlightRanges.length === 0) {
		return <span className={className}>{text}</span>;
	}

	const parts = [];
	let cursor = 0;

	for (const [start, end] of highlightRanges) {
		if (start > cursor) {
			parts.push(text.slice(cursor, start));
		}

		parts.push(
			<mark key={`${start}-${end}`} className={markerClassName}>
				{text.slice(start, end)}
			</mark>,
		);
		cursor = end;
	}

	if (cursor < text.length) {
		parts.push(text.slice(cursor));
	}

	return <span className={className}>{parts}</span>;
};
